import {
  ManagedMessenger,
  TRUST_LEVELS,
  noopLogger,
  noopMetrics,
  targetContextFromWindow,
} from '@sail/comms';
import {
  sailDataObservabilityEventSchema,
  sailDataPrefetchCounterEventSchema,
} from 'src/public/schemas/sailToolkit';

type ObservabilityMessengerConfig = Readonly<{
  remote: Readonly<{
    context: ReturnType<typeof targetContextFromWindow>;
    trustLevel: typeof TRUST_LEVELS.TRUSTED;
    origin: string;
  }>;
  self: Readonly<{
    context: ReturnType<typeof targetContextFromWindow>;
    trustLevel: typeof TRUST_LEVELS.TRUSTED;
  }>;
  logger: typeof noopLogger;
  metrics: typeof noopMetrics;
  schemasByType: Readonly<{
    sail_data_observability_event: typeof sailDataObservabilityEventSchema;
    sail_data_prefetch_counter_event: typeof sailDataPrefetchCounterEventSchema;
  }>;
  communicationId: 'sail-toolkit-page-to-extension';
}>;

type ObservabilityMessenger = ManagedMessenger<ObservabilityMessengerConfig>;

let cachedMessenger: ObservabilityMessenger | null = null;

function createObservabilityMessenger(): ObservabilityMessenger {
  return new ManagedMessenger({
    remote: {
      context: targetContextFromWindow(window),
      trustLevel: TRUST_LEVELS.TRUSTED,
      origin: window.location.origin,
    },
    self: {
      context: targetContextFromWindow(window),
      trustLevel: TRUST_LEVELS.TRUSTED,
    },
    logger: noopLogger,
    metrics: noopMetrics,
    schemasByType: {
      sail_data_observability_event: sailDataObservabilityEventSchema,
      sail_data_prefetch_counter_event: sailDataPrefetchCounterEventSchema,
    },
    communicationId: 'sail-toolkit-page-to-extension',
  });
}

export function getObservabilityMessenger(): ObservabilityMessenger | null {
  if (typeof window === 'undefined' || !window.SAIL_CORE_DEV_TOOLS_PRESENT) {
    return null;
  }
  if (!cachedMessenger) {
    cachedMessenger = createObservabilityMessenger();
  }
  return cachedMessenger;
}
